import { useMedia } from 'react-use'
import queries from '../../../sass/_queries.module.sass'

export const useQueries = (): {
    isMobile: boolean,
    isTablet: boolean,
    isDesktop: boolean,
} => ({
    isMobile: useMedia(queries.mobile),
    isTablet: useMedia(queries.tablet),
    isDesktop: useMedia(queries.desktop)
})